"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IGNORE_STALE_INITIATING_RECORDINGS_THRESHOLD = exports.RECORDING_PER_USER_MS = exports.MAXIMUM_RECORDING_LENGTH_MS = exports.DELETE_RECORDING_TIME_MS = exports.PERSIST_RECORDING_TIME_STILL_SHOW_MS = exports.PERSIST_RECORDING_TIME_MS = exports.PERSIST_RECORDING_TIME_DAYS = exports.createRecordingFileName = exports.RecordingFailedReason = exports.StopRecordingStatus = void 0;
const luxon_1 = require("luxon");
var StopRecordingStatus;
(function (StopRecordingStatus) {
    StopRecordingStatus["Success"] = "Success";
    StopRecordingStatus["StillStarting"] = "Still Starting";
    StopRecordingStatus["RecordingFailed"] = "Recording Failed";
    StopRecordingStatus["Unknown"] = "Unknown";
    StopRecordingStatus["InitFailure"] = "InitFailure";
})(StopRecordingStatus || (exports.StopRecordingStatus = StopRecordingStatus = {}));
var RecordingFailedReason;
(function (RecordingFailedReason) {
    RecordingFailedReason["StartRecording"] = "Failed to start recording";
    RecordingFailedReason["StopRecordingAlreadyStopped"] = "Stop recording: recording already stopped";
    RecordingFailedReason["StopRecordingLimitReached"] = "Stop recording: time limit reached";
    RecordingFailedReason["StopRecordingUnknown"] = "Stop recording: unknown failure";
    RecordingFailedReason["StopRecordingRecordingClient"] = "Stop recording: failed to stop from recording client";
    RecordingFailedReason["FileNotFound"] = "Downloading: Recording file not found";
    RecordingFailedReason["DownloadingError"] = "Downloading: Error downloading";
})(RecordingFailedReason || (exports.RecordingFailedReason = RecordingFailedReason = {}));
const createRecordingFileName = () => {
    const now = luxon_1.DateTime.now();
    return `gather-recording-${now.startOf("second").toISO({
        includeOffset: false,
        includePrefix: false,
        suppressMilliseconds: true,
    })}.mp4`;
};
exports.createRecordingFileName = createRecordingFileName;
exports.PERSIST_RECORDING_TIME_DAYS = 5;
exports.PERSIST_RECORDING_TIME_MS = exports.PERSIST_RECORDING_TIME_DAYS * 24 * 60 * 60 * 1000;
exports.PERSIST_RECORDING_TIME_STILL_SHOW_MS = exports.PERSIST_RECORDING_TIME_MS + 60 * 60 * 1000;
exports.DELETE_RECORDING_TIME_MS = 30 * 24 * 60 * 60 * 1000;
exports.MAXIMUM_RECORDING_LENGTH_MS = 24 * 60 * 60 * 1000;
exports.RECORDING_PER_USER_MS = 2 * 60 * 60 * 1000;
exports.IGNORE_STALE_INITIATING_RECORDINGS_THRESHOLD = 60000;
//# sourceMappingURL=recording.js.map